import axios from "axios";

// On Vercel: REACT_APP_BACKEND_URL is empty → API resolves to "/api" (relative,
// served by Vercel Python serverless functions in /api/*.py).
// On Emergent: REACT_APP_BACKEND_URL is set to the preview URL → API hits the
// FastAPI backend at /app/backend/server.py.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload, { timeout: 15000 });
  return data;
};
